module.exports = __webpack_public_path__ + "gym-43283c38e242d3b4d68bf16b08197e11.svg";